import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlightScheduleComponent } from './flight-schedule.component';
import { APP_ROUTES_MAIN } from './flight-schedule.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateComponent } from './create/create.component';
import { ListComponent } from './list/list.component';
import { SharedModule } from '../../shared/shared.module';
import { DataTablesModule } from 'angular-datatables';
import { ListPassengersComponent } from './list-passengers/list-passengers.component';

@NgModule({
  declarations: [
    FlightScheduleComponent,
    CreateComponent,
    ListComponent,
    ListPassengersComponent
  ],
  imports: [
    APP_ROUTES_MAIN,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    DataTablesModule
  ]
})
export class FlightScheduleModule { }
